import { datadogRum } from "@datadog/browser-rum";

import { AuthUser } from "store/types";

export const initDatadog = () =>
  datadogRum.init({
    applicationId: process.env.REACT_APP_DATADOG_APPLICATION_ID!,
    clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN!,
    site: process.env.REACT_APP_DATADOG_SITE || "datadoghq.com",
    service: process.env.REACT_APP_DATADOG_SERVICE || "dashboard",
    env: process.env.REACT_APP_DATADOG_ENV || "production",
    version: process.env.REACT_APP_VERSION || "1.0.0",
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "mask-user-input",
  });

export const setDatadogUser = (user: AuthUser | null) => {
  if (user) {
    datadogRum.setUser({
      id: user.id,
      name: user.name,
      email: user.email,
    });
  } else {
    datadogRum.clearUser();
  }
};

export default initDatadog;
